import { useState } from "react";
import { Controller, useController } from "react-hook-form";
import {
  BUTTON_SELECT,
  FIELD_REQUIRED,
  FORM,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getReactHookFormNestedError } from "../../utils/errors";
import _ from "lodash";
import Button from "../Buttons/Button";
import ModalLeadFormsList from "./ModalLeadFormsList";

const LeadFormContainer = ({
  name,
  integrationID,
  adAccountID,
  control,
  errors = {},
  disabled,
}) => {
  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
    defaultValue: "",
  });
  const [modalTemplateOpen, setModalTemplateOpen] = useState(false);
  const error = getReactHookFormNestedError(errors, name);
  const { t } = useTranslationApp();

  const onToggleModalTemplate = () => {
    if (disabled) return;
    setModalTemplateOpen((prev) => !prev);
  };

  const isEmptyTemplate = _.isEmpty(value);
  return (
    <Controller
      name={name}
      id={name}
      control={control}
      rules={{
        required: {
          value: true,
          message: t(FIELD_REQUIRED),
        },
      }}
      render={() => (
        <Box id={name}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            {!isEmptyTemplate && (
              <Box
                sx={{
                  width: "100%",
                }}
              >
                <Typography variant="body2">{`${t(FORM)}: ${
                  value.name
                }`}</Typography>

                {!disabled && (
                  <Button
                    type="button"
                    color="secondary"
                    onClick={onToggleModalTemplate}
                    disabled={disabled}
                    sx={{
                      mt: 1,
                      width: "100%",
                    }}
                  >
                    {t(BUTTON_SELECT)}
                  </Button>
                )}
              </Box>
            )}
            {isEmptyTemplate && (
              <Button
                type="button"
                color="secondary"
                onClick={onToggleModalTemplate}
                disabled={disabled}
                sx={{
                  mt: 1,
                  width: "100%",
                }}
              >
                {t(BUTTON_SELECT)}
              </Button>
            )}
          </Box>
          {error?.message && (
            <Typography
              variant="body2"
              color="error"
              sx={{
                mt: 1,
              }}
            >
              {error.message}
            </Typography>
          )}
          {modalTemplateOpen && (
            <ModalLeadFormsList
              modalOpen={modalTemplateOpen}
              onCloseModal={onToggleModalTemplate}
              integrationID={integrationID}
              adAccountID={adAccountID}
              onCallbackSelect={(data) => {
                onChange(data);
              }}
            />
          )}
        </Box>
      )}
    />
  );
};

export default LeadFormContainer;
